import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "currency",
    standalone: false
})
export class CurrencyFormatterPipe implements PipeTransform {
	transform(
		value: number | null | undefined,
		currency: string = "EUR",
		locale: string = "es-ES"
	): string {
		if (value === null || value === undefined || isNaN(value)) {
			return "-";
		}

		try {
			return new Intl.NumberFormat(locale, {
				style: "currency",
				currency,
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(value);
		} catch {
			// Fallback for formatting errors
			return `${value} ${currency}`;
		}
	}
}
